<template>
    <div class="part1 part_box">
        <div class="part1_box fix">
            <div class="part1_l f-fl">
                <div class="ship_way">
                    {{cruiseDetail.routeName}}
                </div>
                <div class="ship_time">
                    <span>{{cruiseDetail.sailDateBegin}} - {{cruiseDetail.sailDateEnd}}</span>
                    <span>{{cruiseDetail.sailDays}}天{{cruiseDetail.sailDays - 1}}晚</span>
                    <span>
                        <a :href="shipLink" target="_blank">{{cruiseDetail.shipName}}</a>
                    </span>
                    <span class="more_day" @click="showMoreSailDatePopup()">
                        <i class="detail_ico_25 calender_ico">
                            <img class="calender_ico" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-date-1.jpg"></i>
                            更多日期
                    </span>
                </div>
                <div class="ship_tags">
                    <CruiseTag
                    v-for="(tag, i) in tags" :key="('tag_' + i)"
                    :tag="tag"
                    :index="('tag_' + i)"
                    />
                    <span class="tag-tips" @click="showCruisePromoInfo()">
                        优惠说明
                        <img class="det_icon" src="https://resource.rcclchina.com.cn/tui2/info/webhao.png">
                    </span>

                </div>
                <div class="receive-coupon"
                     v-if="coupons&&coupons.length>0"
                     ref="couponsContent"
                     @mousedown="startDragCoupon"
                     @mousemove="onDragCoupon"
                     @mouseup="stopDragCoupon"
                     @mouseleave="stopDragCoupon">
                  <div class="coupon-item" :class="i.couponState===2 ? 'coupon-claimed':''"
                       v-for="(i,idx) in coupons" :key="idx"
                       @click="onGetCouponClick(i)">
                    <div class="item-left">
                      {{i.promotion}}
                    </div>
                    <div class="item-right">
                      <span v-if="i.couponState===1">领</span>
                      <span v-else>已领</span>
                    </div>
                  </div>
                </div>
                <div class="ship_time route-tips">
                    <span>游轮航线行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</span>
                </div>
            </div>
            <div class="part1_r f-fr">
                <div class="like_num" @click="onWishListClick()">
                    <i class="detail_ico_40 lick" :class="{ nolike: !isInWishList}"></i><br>
                    <div class="collectionsCount">{{collections}}</div>
                </div>
<!--                <div class="get_coupon" @click="showCruiseCoupon()" v-if="coupons&&coupons.length>0">-->
<!--                    <img src="https://resource.rcclchina.com.cn/tui2/detail/get_coupon.png" alt="">-->
<!--                </div>-->
            </div>
        </div>

        <MoreSailDatePopup
            :isShow="isShowMoreSailDatePopup"
            :cruise="moreSailDateCruise"
            :moreSailDatePopupClose="moreSailDatePopupClose"
            :showLoginPopup="showLoginPopup"
        />
        <CruisePromoInfoPopup
            :isShow="isShowCruisePromoInfoPopup"
            v-on:onModalClose="closeCruisePromoInfo"
        />
        <CruiseCouponPopup
            :isShow="isShowCruiseCoupon"
            :coupons="coupons"
            :showLoginPopup="showLoginPopup"
            :onCouponRuleClick="showCouponRule"
            :setCouponRecieved="setCouponRecieved"
            v-on:onModalClose="closeCruiseCoupon"
        />
        <CruiseCouponRulePopup
            :isShow="isShowCouponRule"
            :couponRule="couponRule"
            v-on:onModalClose="closeCouponRule"
        />
    </div>

</template>

<script>
import api from '@/api'
const MoreSailDatePopup = () => import('@/components/Cruise/MoreSailDatePopup.vue')
const CruiseTag = () => import('@/components/Cruise/CruiseTag.vue')
const CruisePromoInfoPopup = () => import('@/components/Cruise/CruiseDetail/CruisePromoInfoPopup.vue')
const CruiseCouponPopup = () => import('@/components/Cruise/CruiseDetail/CruiseCouponPopup.vue')
const CruiseCouponRulePopup = () => import('@/components/Cruise/CruiseDetail/CruiseCouponRulePopup.vue')
export default {
    name: "CruiseDetailCruiseInfo",
    components: {
        MoreSailDatePopup,
        CruiseTag,
        CruisePromoInfoPopup,
        CruiseCouponPopup,
        CruiseCouponRulePopup
    },
    props: {
        cruiseDetail: {
            type: Object
        },
        showLoginPopup: {
            type: Function
        },
        couponsList:{
            type: Array
        }
    },
    data () {
        return {
            coupons: [],
            isInWishList: false,
            collections: 0,
            isShowCruiseCoupon: false,
            isShowCouponRule: false,
            isShowMoreSailDatePopup: false,
            isShowCruisePromoInfoPopup: false,
            couponRule: '',
            isDragging: false,
            dragStartX: 0,
            scrollLeft: 0,
            dragDistance: 0,
            dragThreshold: 5, // 设置滑动阈值
        }
    },
    beforeMount (){
        this.getWishListStatus()
        if (this.cruiseCoupons && this.cruiseCoupons.length != this.coupons) {
            this.coupons = this.cruiseCoupons
        }
        this.$nextTick(() => {
          this.$refs.couponsContent = this.$el.querySelector('.receive-coupon');
        });
    },
    methods: {
        async getWishListStatus() {
            const userToken = this.$store.state.user.userToken
            const { data } = await api.cruise.isInWishList({
                userName: userToken,
                cruiseId: this.cruiseDetail.cruiseId,
            })
            if (data) {
                this.isInWishList = data.inWishList
                this.collections = data.collections
            }
        },
        onWishListClick () {
            if (this.isInWishList) {
                this.deleteWishList()
            } else {
                this.addWishList()
            }
        },
        async addWishList () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        self.showLoginPopup(()=> {
                            self.addWishList()
                        })
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: this.cruiseDetail.cruiseId,
                source: 'PC'
            }
            this.$loading.show()
            const { success } = await api.cruise.addWishList(requestData)
            if (success) {
                this.isInWishList = true
                this.collections++
            }
            this.$loading.hide()
        },
        async deleteWishList () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        self.showLoginPopup(()=> {
                            self.deleteWishList()
                        })
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: this.cruiseDetail.cruiseId,
                source: 'PC'
            }
            this.$loading.show()
            const { success } = await api.cruise.deleteWishList(requestData)
            if (success) {
                this.isInWishList = false
                if (this.collections > 0) {
                    this.collections--
                }
            }
            this.$loading.hide()
        },
        showCruiseCoupon () {
            this.isShowCruiseCoupon = true
        },
        closeCruiseCoupon () {
            this.isShowCruiseCoupon = false
        },
        showMoreSailDatePopup () {
            this.isShowMoreSailDatePopup = true
        },
        moreSailDatePopupClose () {
            this.isShowMoreSailDatePopup = false
        },
        setCouponRecieved (id) {
            let coupon = this.coupons.find(r=>r.id == id && r.couponState == 1)
            if (coupon) {
                coupon.couponState = 2
            }
        },
        showCouponRule (couponRule) {
            this.couponRule = couponRule
            this.isShowCouponRule = true
        },
        closeCouponRule () {
            this.couponRule = ''
            this.isShowCouponRule = false
        },
        showCruisePromoInfo () {
            this.isShowCruisePromoInfoPopup = true
        },
        closeCruisePromoInfo() {
            this.isShowCruisePromoInfoPopup = false
        },
        async onGetCouponClick(coupon) {
          if (coupon.couponState == 2) {
            return
          }
          const userToken = this.$store.state.user.userToken
          if (!userToken || userToken.length == 0) {
            const self = this
            this.$confirm.show('您尚未登录， 请登录之后， 再领取优惠券', {
              confirmCallBack: () => {
                self.showLoginPopup(()=> {
                  // self.onGetCouponClick(coupon)
                })
              }
            })
            return
          }
          this.$loading.show()
          const { success, errMsg } = await api.booking.giveUserCoupon({
            id: coupon.id,
            source: 'online'
          })
          this.$loading.hide()
          if (!success) {
            this.$alert.show(errMsg)
            return
          }
          this.$alert.show("恭喜您成功领取该优惠券！")
          this.setCouponRecieved(coupon.id)
        },
        startDragCoupon(e) {
          this.isDragging = true;
          this.dragStartX = e.clientX;
          this.scrollLeft = this.$refs.couponsContent.scrollLeft;
          this.dragDistance = 0; // 重置拖拽距离
        },

        onDragCoupon(e) {
          if (!this.isDragging) return;
          e.preventDefault();
          const x = e.clientX;
          const walk = x - this.dragStartX;
          this.dragDistance = Math.abs(walk); // 更新拖拽距离
          this.$refs.couponsContent.scrollLeft = this.scrollLeft - walk;
        },

        stopDragCoupon() {
          this.isDragging = false;
        },
    },
    computed: {
        tags () {
            let tags = []
            if (this.cruiseDetail && this.cruiseDetail.tags) {
                this.cruiseDetail.tags.forEach(tag => {
                    tags.push({
                        tagType: tag.name,
                        tagDescription: tag.description,
                        isHighShow: tag.isHighShow
                    })
                })
            }
            return tags
        },
        moreSailDateCruise () {
            return {
                cruiseName: this.cruiseDetail.routeName,
                shipCode: this.cruiseDetail.shipCode,
                sailDate: this.cruiseDetail.sailDate
            }
        },
        cruiseCoupons() {
            return this.couponsList || []
        },
        shipLink () {
            if (this.cruiseDetail.shipCode === 'WN') {
                return 'https://www.rcclchina.com.cn/privilege/WN2021'
            }
            return process.env.VUE_APP_BASE_URL + '/content/taste/ships/' + this.cruiseDetail.shipCode
        }
    },
    watch: {
        cruiseCoupons (newOne) {
            this.coupons = newOne
        },
        cruiseDetail(newValue) {
            if (newValue && newValue.cruiseId > 0) {
                this.getWishListStatus()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.part1 {
    .part1_l.f-fl {
        width: 950px;
        .ship_way {
            font-size: 30px;
            color: #282b2c;
            font-weight: bold;
        }
        .ship_tags{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }
        .receive-coupon{
          display: flex;
          align-items: center;
          gap: 17px;
          overflow-x: auto;
          overflow-y: hidden;
          width: 120%;
          //隐藏滚动条
          & ::-webkit-scrollbar {
            display: none;
          }
          scrollbar-width: none; /* Firefox */
          -ms-overflow-style: none;
          .coupon-item{
            width: 230px;
            background: url("https://resource.rcclchina.com.cn/TUI2PCImg/coupon-bg.png") no-repeat;
            background-size: 100% 100%;
            margin-top: 15px;
            font-size: 15px;
            color: #ffffff;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            cursor: pointer;
            & .item-left{
              width: 188px;
              padding: 0 15px;
              height: 35px;
              line-height: 35px;;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-align: center;
            }
            & .item-right{
              width: 42px;
              text-align: center;
            }
          }
          .coupon-claimed{
            color: #fb6b15;
            background: url("https://resource.rcclchina.com.cn/TUI2PCImg/coupon-claimed-bg.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        .ship_time {
            font-size: 16px;
            color: #282b2c;
            padding: 5px 0px;
            span {
                margin-right: 20px;
            }
            .more_day {
                color: #0073bb;
                position: relative;
                left: -21px;
                cursor: pointer;
                .calender_ico {
                    position: relative;
                    top: -1px;
                    left: 5px;
                    margin-right: 6px;
                }
            }
        }
        .ship_tags::after {
            content: '';
            clear: both;
        }
        .route-tips {
            clear: both;
            position: relative;
            top: 10px;
            color: #999999;
        }
        .tag-tips {
            color: #0073bb;
            font-size: 12px;
            cursor: pointer;
            font-weight: 400;
            position: relative;
            top: 8px;
            img {
                position: relative;
                top: -1px;
                left: 3px;
            }
        }
    }
    .part1_r {
        .like_num {
            text-align: center;
            font-size: 12px;
            width: 40px;
            margin: 0px 0px 20px 160px;
        }
        .get_coupon {
            display: block;
            cursor: pointer;
        }
    }
}
</style>
